import type { CareStateRequestUrgencyT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { cn } from '@/lib/utils';

const URGENCY_BG: Readonly<Record<CareStateRequestUrgencyT, string>> = {
  Urgent: 'bg-urgent-outline',
  Routine: 'bg-routine-outline',
};

const URGENCY_DOT_BG: Readonly<Record<CareStateRequestUrgencyT, string>> = {
  Urgent: 'bg-urgent-foreground',
  Routine: 'bg-routine-foreground',
};

export interface UrgencyPillProps {
  urgency: CareStateRequestUrgencyT;
  className?: string;
}

export function UrgencyPill({ urgency, className }: UrgencyPillProps) {
  return (
    <span
      aria-label={`Urgency: ${urgency}`}
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-0.5 text-sm font-medium text-foreground',
        URGENCY_BG[urgency],
        className
      )}
    >
      <span aria-hidden="true" className={cn('size-1.5 rounded-full', URGENCY_DOT_BG[urgency])} />
      {urgency}
    </span>
  );
}
